var exports = {
  "wx": "GuildHeaderBottomSheet.module__header___S0pUSz",
  "R3": "GuildHeaderBottomSheet.module__avatarWrapper___S0pUSz",
  "Kk": "GuildHeaderBottomSheet.module__icon___S0pUSz",
  "Qq": "GuildHeaderBottomSheet.module__text___S0pUSz",
  "DD": "GuildHeaderBottomSheet.module__title___S0pUSz",
  "M1": "GuildHeaderBottomSheet.module__stats___S0pUSz",
  "dJ": "GuildHeaderBottomSheet.module__stat___S0pUSz",
  "gW": "GuildHeaderBottomSheet.module__statDot___S0pUSz",
  "rR": "GuildHeaderBottomSheet.module__statDotOnline___S0pUSz",
  "rb": "GuildHeaderBottomSheet.module__statDotMembers___S0pUSz",
  "KA": "GuildHeaderBottomSheet.module__statText___S0pUSz",
};

module.exports = exports;
